// import React from 'react'
// import ReactDOM from 'react-dom'
import 'open-props/style'
import './styles/index.css'
import App from './App'
// import reportWebVitals from './reportWebVitals'

/*ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);*/
const app = new App('root')
app.init()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
